import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Form, Row, Col, Button } from 'react-bootstrap';
import { forgotPasswordRequest } from '../../store/account/userActions';
import { NavLink, useHistory } from 'react-router-dom';
import HCaptcha from '@hcaptcha/react-hcaptcha';
import './ForgotPassword.scss';
import { Mail,  } from 'lucide-react';

function ForgotPassword({ forgotpassword }) {
  const history = useHistory();
  const [state, setState] = useState({ data: { email: '' }, errors: {} });
  const [captchaToken, setCaptchaToken] = useState(null);
  const [captchaError, setCaptchaError] = useState('');

  const validate = () => {
    const { data } = state;
    const errors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!data.email) {
      errors.email = 'Email cannot be blank.';
    } else if (!emailRegex.test(data.email)) {
      errors.email = 'Invalid email format.';
    }

    if (!captchaToken) {
      setCaptchaError('Please complete the captcha verification.');
    } else {
      setCaptchaError('');
    }

    return errors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = validate();

    if (Object.keys(errors).length === 0 && captchaToken) {
      forgotpassword({ ...state.data, captchaToken });
      setState({ data: { email: '' }, errors: {} });
      setCaptchaToken(null);
      setCaptchaError('');
      setTimeout(() => history.push('/login'), 2000);
    } else {
      setState((prev) => ({ ...prev, errors }));
    }
  };

  const handleChange = (e) => {
    setState({
      data: { ...state.data, [e.target.id]: e.target.value },
      errors: { ...state.errors, [e.target.id]: '' },
    });
  };

  return (
    <div className="modern-forgot-password">
      <Row className="form-wrapper">
        <Col lg={6} className="left-panel d-none d-lg-flex">
          <div className="left-content text-center">
            <h1>
              {/* <RotateCcwKey size={28} /> */}
              Forgot your password?
            </h1>
            <p>Reset access to your MultiSignals account in just a few steps.</p>
          </div>
        </Col>

        <Col xs={12} lg={6} className="right-panel">
          <div className="form-container">
            <h3 className="form-title">Reset Password</h3>
            <p className="form-subtitle">Enter your email to receive reset instructions.</p>

            <Form onSubmit={handleSubmit} className="mt-4">
              <Form.Group controlId="email" className="mb-3">
                <Form.Label>Email Address</Form.Label>
                <div className="input-icon-group">
                  <Mail size={16} />
                  <Form.Control
                    type="email"
                    placeholder="you@example.com"
                    value={state.data.email}
                    onChange={handleChange}
                    isInvalid={!!state.errors.email}
                  />
                </div>
                {state.errors.email && (
                  <Form.Text className="text-danger">{state.errors.email}</Form.Text>
                )}
              </Form.Group>

              <div className="captcha-wrapper">
                <HCaptcha
                  sitekey={process.env.REACT_APP_HCAPTCHA_SITE_KEY}
                  onVerify={setCaptchaToken}
                />
                {captchaError && (
                  <Form.Text className="text-danger">{captchaError}</Form.Text>
                )}
              </div>

              <Button type="submit" className="modern-submit-btn mt-3">
                Send Reset Link
              </Button>
            </Form>

            <div className="mt-4 text-center">
              <NavLink to="/login" className="back-link">
                ← Back to Login
              </NavLink>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

const mapDispatchToProps = (dispatch) => ({
  forgotpassword: (creds) => dispatch(forgotPasswordRequest(creds)),
});

export default connect(null, mapDispatchToProps)(ForgotPassword);
